import { z } from "zod"

// Define the schema for the SeriesMeasure object
export const seriesMeasureSchema = z.object({
  /** The identifier of the series that this data
   * point belongs to (See Series above). */
  seriesId: z.number(),
  /** Start date and time of this data point. */
  fromDateTime: z.string(),
  /** End date and time of this data point. */
  toDateTime: z.string(),
  /** The average rate of charge for this timeframe,
   * denominated in the major currency applicable.
   * For instance, in USD this would be 0.12 for 12 cents. */
  rate: z.number().optional().nullable(),
  /** Quantity for this timeframe (usage or production, etc.
   * typically in kWh). */
  qty: z.number(),
  /** Cost (or savings) of this timeframe. */
  cost: z.number(),
})

// Exported type for the SeriesMeasure object
export type SeriesMeasure = z.infer<typeof seriesMeasureSchema>
